import AppLayout from "../layout/AppLayout";
import ProfileForm from "../components/settings/ProfileForm";
import PasswordForm from "../components/settings/PasswordForm";
import TwoFactorForm from "../components/settings/TwoFactorForm";

export default function SettingsPage() {
  return (
    <AppLayout>
      <div className="mx-auto flex max-w-3xl flex-col gap-6">
        <h1 className="font-heading text-2xl text-dantzBlue">My profile</h1>
        <ProfileForm />
        <PasswordForm />
        <TwoFactorForm />
      </div>
    </AppLayout>
  );
}
